module.exports = __webpack_public_path__ + "06_medium_gray.1d7744cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/06_medium_gray.png
// module id = SN0R
// module chunks = 0